import React, { useCallback, useEffect, useState } from 'react';
import { listAudit, auditCsv } from '../api/modulesApi';
import { errorMessage } from '../api/securityApi';
import ModuleNav from '../components/Modules/ModuleNav';

export default function AuditLogPage() {
  const [f, setF] = useState({ search: '', user: '', from: '', to: '' });
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], totalCount: 0, pageSize: 50 });
  const [error, setError] = useState('');
  const params = useCallback((p) => ({
    search: f.search, user: f.user, page: p, pageSize: 50,
    from: f.from ? new Date(f.from).toISOString() : '', to: f.to ? new Date(f.to + 'T23:59:59').toISOString() : '',
  }), [f]);
  const load = useCallback(async (p = 1) => {
    try { setError(''); setPage(p); setData(await listAudit(params(p))); } catch (e) { setError(errorMessage(e)); }
  }, [params]);
  useEffect(() => { load(1); /* eslint-disable-next-line */ }, []);
  const pages = Math.max(1, Math.ceil(data.totalCount / data.pageSize));

  return (
    <div className="shell">
      <header className="page-header"><div><h1>Audit log</h1><p className="muted">Every change made through the dashboard: who, what, from which address.</p></div></header>
      <ModuleNav />
      {error && <div className="toast error">{error}</div>}
      <form className="sec-card sec-row" onSubmit={(e) => { e.preventDefault(); load(1); }}>
        <input className="sec-input" placeholder="Search action / detail" value={f.search} onChange={(e) => setF({ ...f, search: e.target.value })} />
        <input className="sec-input" placeholder="User e-mail" value={f.user} onChange={(e) => setF({ ...f, user: e.target.value })} />
        <input className="sec-input" type="date" value={f.from} onChange={(e) => setF({ ...f, from: e.target.value })} />
        <input className="sec-input" type="date" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} />
        <button className="primary" type="submit">Filter</button>
        <button type="button" className="ghost" onClick={() => auditCsv(params(1)).catch((e) => setError(errorMessage(e)))}>Export CSV</button>
      </form>
      <div className="sec-card sec-scroll">
        <table className="sec-table"><thead><tr><th>Time</th><th>User</th><th>Action</th><th>Entity</th><th>Detail</th><th>IP</th></tr></thead>
          <tbody>{data.items.map((a) => (
            <tr key={a.id}><td>{new Date(a.createdAt).toLocaleString()}</td><td>{a.userEmail}</td><td className="sec-mono">{a.action}</td><td>{a.entityType}</td><td>{a.detail}</td><td className="sec-mono">{a.ipAddress}</td></tr>))}
            {data.items.length === 0 && <tr><td colSpan="6" className="muted">No entries.</td></tr>}</tbody></table>
        <div className="sec-row" style={{ justifyContent: 'space-between', marginTop: 10 }}>
          <span className="muted">{data.totalCount.toLocaleString()} entries</span>
          <div className="sec-row"><button className="ghost" disabled={page <= 1} onClick={() => load(page - 1)}>Previous</button>
            <span>Page {page} of {pages}</span><button className="ghost" disabled={page >= pages} onClick={() => load(page + 1)}>Next</button></div>
        </div>
      </div>
    </div>
  );
}
